export default function ConvertPixelToRem(px) {
    return (px / 16) + 'rem';
}